// extracted by mini-css-extract-plugin
module.exports = {"img":"Avatar_img__3rA9l","imgBorder":"Avatar_imgBorder__391LR"};